export default __webpack_public_path__ + "static/media/illustration_login.227faac3.png";